import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { DomainService } from './domain.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class HtmlMetaService {
  constructor(
    private titleService: Title,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public domainService: DomainService,
    private translate: TranslateService
  ) {}

  updateTitle(title?: string) {
    let suffixTitle =
      this.domainService.getCurrentDomain()['name'] ?? 'Meet the Youngsters';

    if (!title) {
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          map(() => this.activatedRoute),
          map((route) => {
            while (route.firstChild) {
              route = route.firstChild;
            }
            return route;
          }),
          filter((route) => route.outlet === 'primary'),
          mergeMap((route) => route.data)
        )
        .subscribe((event) => {
          if (event.hasOwnProperty('title')) {
            this.translate.get(event['title']).subscribe((titleTranslated) => {
              this.titleService.setTitle(titleTranslated + ' | ' + suffixTitle);
            });
          } else {
            this.titleService.setTitle(suffixTitle);
          }
        });
    } else {
      this.titleService.setTitle(title + ' | ' + suffixTitle);
    }
  }
}
